import React, { useState } from 'react';

import { Row, Col } from 'react-bootstrap';

import startIcon from 'images/icons/invite/play.svg';
import editIcon from 'images/icons/invite/edit.svg';
import modalIcon from 'images/icons/build/add-icon.svg';
import ModalWithoutTitle from '../../../../ui/ModalWithoutTitle';

import { useContext } from '../../Context';

export default function Actions({
  row,
  startEdit,
  startCreate,
  showChoosePlanModal,
}) {
  const { dispatch, actions, state } = useContext();

  const [showModal, setShowModal] = useState(false);

  const editPlan = (e, row) => {
    if (state.policy.attributes.is_lock) {
      return;
    }
    startEdit(row);
  };

  const startRenewal = (e, row) => {
    if (state.policy.attributes.is_lock) {
      return;
    }

    if (
      row.attributes.renewal_method == 'automatic'
      || row.attributes.renewal_method == 'terminated'
    ) {
      swal(
        {
          title: '',
          text: 'Do you want to renew this plan?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Renew',
          cancelButtonText: 'Cancel',
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        (isConfirm) => {
          if (isConfirm) {
            let el = e.target;
            while (el && el.tagName !== 'A') {
              el = el.parentNode;
            }

            el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
            actions.renewalPlan(dispatch, state.enterpriseId, row.id, () => {
              actions.load(dispatch, state.enterpriseId);
            });
          }
        },
      );
    } else {
      setShowModal(true);
    }
  };

  const showChooseTemplate = (e) => {
    e.stopPropagation();
    setShowModal(false);
    showChoosePlanModal(row);
  };

  const prepareTemplate = (e) => {
    e.stopPropagation();
    actions.prepareTemplate(state.enterpriseId, { planId: row.id }, (plan) => {
      // onHide();
      // setLoader(false);
      startCreate(plan);
    });
  };

  return (
    <>
      <div>
        {row.attributes.status == 'active' && (
          <a
            data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
            onClick={(e) => startRenewal(e, row)}
            className="mr10"
          >
            <img src={startIcon} />
          </a>
        )}
        <a
          data-tip={state.policy.attributes.is_lock ? 'Unlock policy first' : null}
          onClick={(e) => editPlan(e, row)}
          className="mr10"
        >
          <img src={editIcon} />
        </a>
      </div>
      <ModalWithoutTitle show={showModal} onHide={() => setShowModal(false)}>
        <div className="build_program-modal create_program-modal">
          <div className="programModal_logo">
            <img src={modalIcon} />
          </div>
          <div className="programModal_title text-h3">Create a New Plan</div>

          <div className="programModal_txt">
            <p>
              Would you like to adjust the current plan or create one from
              scratch?
            </p>
          </div>
          <div className="programModal_buttons">
            <button
              onClick={prepareTemplate}
              className="button-use manager-build-program-choose-template"
            >
              Current Plan
            </button>
            <button
              onClick={showChooseTemplate}
              className="button-create bckg-green manager-build-program-new-template"
            >
              Create New
            </button>
          </div>
        </div>
      </ModalWithoutTitle>
    </>
  );
}
